import { render, staticRenderFns } from "./CustomerRegistration.vue?vue&type=template&id=073a273a&scoped=true&"
import script from "./CustomerRegistration.vue?vue&type=script&lang=js&"
export * from "./CustomerRegistration.vue?vue&type=script&lang=js&"
import style0 from "./CustomerRegistration.vue?vue&type=style&index=0&id=073a273a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073a273a",
  null
  
)

export default component.exports